import Grid from "@mui/material/Grid";

import EmptyListView from "../ListComponents/EmptyListView";

import { Stack } from "@mui/material";
import WheelCard from "../../WheelListing/ListComponents/WheelCard";
import WheelGridSkeletonLoader from "../ListComponents/WheelGridSkeletonLoader";
import ListView from "./ListView";
import WheelTableSkeletonLoader from "../ListComponents/WheelTableSkeletonLoader";

const List = ({
  wheels,
  isLoading,
  isFetchingNextPage,
  isError,
  error,
  onWheelDelete = () => {},
  onWheelReactivate = () => {},
  wheelCategory,
  isGridView = false,
}) => {
  // Handle error state
  if (isError) {
    return (
      <Stack justifyContent="center" alignItems="center" sx={{ mt: 5 }}>
        <div>Error: {error?.message || "Something went wrong!"}</div>
      </Stack>
    );
  }

  // Handle loading state
  if (isLoading && !wheels?.length) {
    return isGridView ? (
      <WheelGridSkeletonLoader />
    ) : (
      <WheelTableSkeletonLoader />
    );
  }

  // Handle empty state
  if (wheels?.length === 0) {
    return <EmptyListView selectedTab={wheelCategory} />;
  }

  if (!isGridView)
    return (
      <Stack gap={1}>
        <ListView 
          tabType={wheelCategory} 
          wheels={wheels}
          onWheelDelete={onWheelDelete}
          onWheelReactivate={onWheelReactivate}
        />
        {isFetchingNextPage && <WheelTableSkeletonLoader count={2} />}
      </Stack>
    );

  return (
    <Grid container>
      <Grid container spacing={2}>
        {wheels.map((wheel) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={wheel.id}>
            <WheelCard
              onWheelDelete={onWheelDelete}
              onReactivate={onWheelReactivate}
              data={wheel}
              wheelCategory={wheelCategory}
            />
          </Grid>
        ))}
      </Grid>
      <div style={{ minHeight: 260, marginTop: 16, width: "100%" }}>
        {isFetchingNextPage && <WheelGridSkeletonLoader count={4} />}
      </div>
    </Grid>
  );
};

export default List;
